import fetch from 'utils/fetch';
import { success } from 'plugins/toastr';

export const REQUEST_SEND_MESSAGE = 'REQUEST_SEND_MESSAGE';
export const MESSAGE_SENT = 'MESSAGE_SENT';
export const MESSAGE_SEND_ERROR = 'MESSAGE_SEND_ERROR';

function requestSend(message, recipients) {
  return {
    type: REQUEST_SEND_MESSAGE,
    payload: {
      message,
      recipients,
    },
  };
}

function messageSent(messages, recipients) {
  return {
    type: MESSAGE_SENT,
    payload: {
      messages,
      recipients,
    },
  };
}

function messageSendError(error) {
  return {
    type: MESSAGE_SEND_ERROR,
    payload: {
      error,
    },
  };
}

export function sendMessage(message, recipients) {
  return dispatch => {
    const json = JSON.stringify({
      content: message.content,
      recipients: recipients.map(r => Number(r)),
    });

    const data = new FormData();
    data.append('message', json);
    data.append('image', message.image);

    dispatch(requestSend(message, recipients));
    fetch('/messaging/messages', {
      method: 'post',
      body: data,
    })
      .then(r => r.json())
      .then(created => dispatch(messageSent(created, recipients)))
      .then(() => success('Message envoyé avec succès'))
      .catch(error => dispatch(messageSendError(error)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/messaging/actions/message.js